// extracted by mini-css-extract-plugin
module.exports = {"dots":"Carousel-module--dots--3hreX","image":"Carousel-module--image--3K0on"};